import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Monitor } from "lucide-react";
import { formatCZK, SPOLUUCAST_PCT } from "@/data/courses";

export const CourseCard = ({ course, index = 0 }) => {
  const spoluucast = course.spoluucast ?? (course.cena ? Math.round(course.cena * SPOLUUCAST_PCT) : null);
  return (
    <Link
      to={`/kurzy/${course.slug}`}
      data-testid={`course-card-${course.slug}`}
      className="group bg-white border border-gavito-navy/10 rounded-3xl p-8 flex flex-col hover:border-gavito-green hover:shadow-[0_20px_50px_-24px_rgba(27,42,78,0.25)] hover:-translate-y-1 transition-all duration-300 animate-fade-up"
      style={{ animationDelay: `${index * 70}ms` }}
    >
      <div className="flex items-center justify-between gap-3 mb-5">
        {course.dotovany ? (
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-gavito-green/12 text-gavito-green">
            Lze hradit s Úřadem práce
          </span>
        ) : (
          <span />
        )}
        <span className="w-9 h-9 rounded-full bg-gavito-navy/5 flex items-center justify-center text-gavito-navy group-hover:bg-gavito-green group-hover:text-white transition-colors">
          <ArrowUpRight className="w-4 h-4" />
        </span>
      </div>

      <h3 className="font-heading font-bold text-xl md:text-2xl tracking-tight text-gavito-navy leading-snug group-hover:text-gavito-green transition-colors">
        {course.title}
      </h3>
      <p className="text-gavito-navy/60 leading-relaxed mt-3 flex-1">{course.kratkyPopis}</p>

      <div className="flex items-center gap-5 mt-6 text-sm text-gavito-navy/60">
        <span className="inline-flex items-center gap-1.5"><Monitor className="w-4 h-4" />{course.forma}</span>
        <span className="inline-flex items-center gap-1.5"><Clock className="w-4 h-4" />{course.delka}</span>
      </div>

      <div className="mt-6 pt-6 border-t border-gavito-navy/10">
        {course.cena ? (
          <>
            <p className="font-heading font-extrabold text-2xl text-gavito-navy">{formatCZK(course.cena)} <span className="text-sm font-medium text-gavito-navy/50">vč. DPH</span></p>
            {course.dotovany && (
              <p className="text-sm text-gavito-navy/55 mt-1">
                Spoluúčast od <span className="font-semibold text-gavito-green">{formatCZK(spoluucast)}</span> (min. 23,27 %)
              </p>
            )}
          </>
        ) : (
          <p className="font-heading font-extrabold text-2xl text-gavito-navy">Cena na vyžádání</p>
        )}
      </div>
    </Link>
  );
};
